import React from 'react';

export default function findAccount() {
  return <div>계정찾기</div>;
}
